export { NotificationMessagePopUpComponent } from './notification-message-pop-up.component';
